const formatDate = (params) => { 
    if(params.value){
        let dateObj = new Date(params.value)
        return dateObj.toLocaleDateString()
    }else{
        return ''
    }
 }

// Formats date strings with time for grids that need timestamp precision.
const formatDateTime = (params) => {
    if (params.value) {
        const dateObj = new Date(params.value);
        return dateObj.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    return '';
}

const formatDollar = (params) => {
    let dollarString = new Intl.NumberFormat("en-US", {
        style: 'currency',
        currency: 'USD',
     });
    if(params.value){
        return dollarString.format(params.value)
    }else{
        return '$0.00'
    }
}

export {
    formatDate,
    formatDateTime,
    formatDollar
}